/**
 * IMDF Categories 工具函數
 * 提供根據 feature type 取得對應的 category 選項
 */

import categoriesData from '../data/imdf-categories.json';

export interface CategoryOption {
  value: string;
  label: string;
  definition: string;
}

export interface CategoriesData {
  amenity: CategoryOption[];
  occupant: CategoryOption[];
}

// 類型斷言：確保導入的 JSON 資料符合我們的介面
const categories = categoriesData as CategoriesData;

/**
 * 根據 feature type 取得對應的 category 選項列表
 * @param featureType - feature 類型 (amenity 或 occupant)
 * @returns Category 選項陣列
 */
export function getCategoriesByFeatureType(featureType: string): CategoryOption[] {
  if (featureType === 'amenity') {
    return categories.amenity;
  }
  if (featureType === 'occupant') {
    return categories.occupant;
  }
  return [];
}

/**
 * 搜尋符合關鍵字的 categories
 * @param featureType - feature 類型
 * @param searchTerm - 搜尋關鍵字
 * @returns 符合搜尋條件的 Category 選項陣列
 */
export function searchCategories(featureType: string, searchTerm: string): CategoryOption[] {
  const allCategories = getCategoriesByFeatureType(featureType);

  if (!searchTerm || searchTerm.trim() === '') {
    return allCategories;
  }

  const lowerSearchTerm = searchTerm.toLowerCase();

  return allCategories.filter(category =>
    category.value.toLowerCase().includes(lowerSearchTerm) ||
    category.definition.toLowerCase().includes(lowerSearchTerm)
  );
}

/**
 * 取得特定 category 的完整資訊
 * @param featureType - feature 類型
 * @param categoryValue - category 值
 * @returns Category 選項或 undefined
 */
export function getCategoryInfo(featureType: string, categoryValue: string): CategoryOption | undefined {
  const allCategories = getCategoriesByFeatureType(featureType);
  return allCategories.find(cat => cat.value === categoryValue);
}
